import Chart from '@/chart'
import pallete from '@/assets/js/pallete'
import { pdfFontSize } from '../../assets/js/settings'

export function parseData(data, labels){
    
    return data.map(dat => {
        const values = dat ? dat : labels.map(() => 0)
        return values.map(val => 100*val)
    })
}

function getDatasets(data, labels, params){
    
    let colors = pallete

    if (params.pallete){
        colors = [...params.pallete, ...pallete]
    }
    

    return parseData(data, labels, params).map((values, index) => {        
        return {
            data: values,
            backgroundColor: (params.multiColor && data.length===1) ? colors : colors[index]
        }
    })
}

function getOptions(pdf=false){

    let options = {

        indexAxis: 'x',
        scales: {
            y: {
                min: 0,
                //max: 30,
                display: true,
                ticks: {
                    callback: function(value){
                        return `${value}`
                    }
                }
            }
        },
        aspectRatio: 1,
        plugins: {
            legend: {
                display: false
            },
            tooltip: {
                callbacks: {
                    label: function(context){
                        let value = context.raw                      
                        return `${(value).toFixed(1)}`
                    }
                }
            }
        }
    }

    if (pdf) {
        options.animation = false
        options.responsive = false
        options.scales.y.ticks['font'] = {
            size: pdfFontSize
        }
        options.scales['x'] = {
            ticks: {
                font: {
                    size: pdfFontSize
                }
            }
        }
    }

    return options
}

function getConfig(data, labels, params, pdf=false){
    labels = params.alt_states ? params.alt_states : labels
    return {
        type: 'bar',
        data: {
            labels,
            datasets: getDatasets(data, labels, params)
        },
        options: getOptions(pdf),
    }

}

export function initChart(ctx, labels, data, params={}){
    return new Chart(ctx, getConfig(data, labels, params))
}

export function pdfChart(ctx, labels, data, params={}){
    return new Chart(ctx, getConfig(data, labels, params, true))
}
